<template>
  <el-dialog class="k-promocode-edit-form" :title="promocode && promocode._id ? `Редагування промокода ${promocode._id}` : 'Створення нового промокода'" :visible.sync="dialogFormVisible">
    <div class="k-promocode-edit-form__container">
      <p class="k-promocode-edit-form__title">Ви можете відредагувати інформацію про промокод. Та зберегти її у базі даних:</p>

      <el-row :gutter="20" class="k-promocode-edit-form__param">
        <el-col :span="8" class="k-promocode-edit-form__label">Промокод:</el-col>
        <el-col :span="16"><el-input placeholder="Промокод" v-model="code"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-promocode-edit-form__param">
        <el-col :span="8" class="k-promocode-edit-form__label">Скида (0.1 - 1):</el-col>
        <el-col :span="16"><el-input placeholder="Скидка" type="number" v-model="discount" :min="0" :max="1"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-promocode-edit-form__param">
        <el-col :span="8" class="k-promocode-edit-form__label">&nbsp;</el-col>
        <el-col :span="16"><el-checkbox v-model="active">Активний</el-checkbox></el-col>
      </el-row>

      <el-row :gutter="20" class="k-promocode-edit-form__param">
        <el-col :span="8" class="k-promocode-edit-form__label">Дата закінчення:</el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="Дата закінчення">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-promocode-edit-form__param">
        <el-button type="success" round @click="handleSave" size="mini">Зберегти</el-button>
        <el-button round @click="handleCancel" size="mini">Відміна</el-button>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
/**
 * Component: k-promocode-edit-form - Форма для редактирования информации о промокоде
*
* @version 1.0.0
*/

const toStr = param => param ? param : '';
const toBool = param => param ? param : true;

export default {
  name: 'k-promocode-edit-form',

  props: {
    // Является ли форма видимой
    dialogFormVisible: {
      type: Boolean,
      required: true,
    },

    // Данные для отображения
    promocode: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      code: '',
      active: false,
      endDate: null,
      discount: 0,
      categories: [],
    };
  },

  watch: {
    promocode: {
      handler: function(newValue) {
        this.setpromocodeData();
      },
      deep: true,
    },
  },

  async created() {
    await this.getAppSettings();
    if (this.promocode) {
      this.setpromocodeData();
    }
  },

  methods: {
    setpromocodeData() {
      this.code = this.promocode.code ? this.promocode.code : '';
      this.active = this.promocode.active ? this.promocode.active : false;
      this.discount = this.promocode.discount ? this.promocode.discount : 0;
      this.endDate = this.promocode.endDate ? this.promocode.endDate : null;
    },

    // Отмена редактирования
    handleCancel() {
      this.$emit('cancel');
    },

    // Сохранение информации о промокоде на бекенде
    async handleSave() {
      const promocode = {
        code: this.code,
        active: this.active,
        endDate: this.endDate,
        discount: this.discount,
      };

      if (this.promocode._id) {
        promocode._id = this.promocode._id;
      }

      await this.setPromocode(promocode);
      this.$emit('update');
    },

    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },

    ...mapActions({
      getAppSettings: 'settings/getAppSettings',
      setPromocode: 'promocodes/setPromocode',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-promocode-edit-form {
  $this: &;
  $icon-size: 50px;

  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__title {
    margin-bottom: 2 * $vp;
  }

  &__param {
    margin-bottom: $vp;
  }

  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }

  &__icon {
    width: $icon-size;
    height: $icon-size;
    margin: 10px auto;
    border-radius: $icon-size / 2;
    background-color: black;

    & svg {
      width: $icon-size;
      height: $icon-size;
    }
  }
}
</style>
